<template>
  <div class="card border-0 shadow-sm h-100">
    <div class="card-body">
      <div class="row text-center mb-3">
        <div class="col">
          <h2 class="text-success mb-0">{{ priceIncreases }}</h2>
          <p class="text-muted"><i class="fas fa-arrow-up me-1"></i>{{ $t('dashboard.priceIncrease') }}</p>
        </div>
        <div class="col">
          <h2 class="text-danger mb-0">{{ priceDecreases }}</h2>
          <p class="text-muted"><i class="fas fa-arrow-down me-1"></i>{{ $t('dashboard.priceDecrease') }}</p>
        </div>
        <div class="col">
          <h2 class="text-secondary mb-0">{{ noPriceChange }}</h2>
          <p class="text-muted"><i class="fas fa-minus me-1"></i>{{ $t('dashboard.noPriceChange') }}</p>
        </div>
      </div>
      <hr>
      <div class="d-flex justify-content-between align-items-center">
        <p class="text-muted mb-0">{{ $t('dashboard.marketDynamicIndicators') }}</p>
        <p class="text-muted mb-0">{{ totalMonitoredProducts }} {{ $t('dashboard.productsMonitored') }}</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import apiClient from '../../api'; // Adjust path as needed

const priceIncreases = ref(0);
const priceDecreases = ref(0);
const noPriceChange = ref(0);
const totalMonitoredProducts = ref(0);

const fetchPriceChangeData = async () => {
  try {
    console.log('Fetching price change data...'); // Log 1
    const response = await apiClient.get('/dpc/kpis');
    console.log('API Response:', response.data); // Log 2

    if (response.data) {
      priceIncreases.value = response.data.price_increases;
      priceDecreases.value = response.data.price_decreases;
      noPriceChange.value = response.data.no_price_change;
      totalMonitoredProducts.value = response.data.total_monitored_products;
      console.log('Data updated:', {
        priceIncreases: priceIncreases.value,
        priceDecreases: priceDecreases.value,
        noPriceChange: noPriceChange.value,
        totalMonitoredProducts: totalMonitoredProducts.value
      }); // Log 3
    } else {
      console.warn('API response was not successful or data is missing:', response.data); // Log 4
    }
  } catch (error) {
    console.error('Failed to fetch price change data:', error); // Log 5
    // Handle error, maybe set default values or show an error message
  }
};

onMounted(() => {
  fetchPriceChangeData();
});
</script>

<style scoped>
.card-body {
  padding: 1.5rem;
}
</style>